import { Navigate, Outlet } from 'react-router-dom';
import { AppShell } from '../components/AppShell.js';
import { Loading, Notice } from '../components/ui.js';
import { DraftProvider, useDraft } from '../state/DraftContext.js';

export function ReportGate() {
  return (
    <DraftProvider>
      <ReportGateInner />
    </DraftProvider>
  );
}

function ReportGateInner() {
  const { loading, error, draft } = useDraft();
  if (loading)
    return (
      <AppShell language="en">
        <Loading label="Preparing your secure report..." />
      </AppShell>
    );
  if (error || !draft) {
    return (
      <AppShell language="en">
        <section className="center-card">
          <h1>A venue invitation is required</h1>
          <Notice tone="warning">Scan the QR code provided by the venue team.</Notice>
        </section>
      </AppShell>
    );
  }
  if (window.location.pathname === '/report') return <Navigate to="/report/intake" replace />;
  return <Outlet />;
}
